import { Pagination } from 'types'

export const ROLE_RELATION_INITIAL_PAGINATION: Pagination = {
  page: 1,
  limit: 15,
  sort: {
    by: 'role_name',
    order: 'ASC',
  },
}
